// extracted by mini-css-extract-plugin
export default {"description":"_2VcxnR1NDCe9xmFmqBo7Wd"};